import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';

export default function IconContainer(props) {
  const { icons, affiliations } = props;
  if (!icons) return;
  return (
    <div className="inner-width-container">
      <Container>
        {icons.map((icon, index) => (
          <Icon key={index} {...icon} affiliations={affiliations}/>
        ))}
      </Container>
    </div>
  );
}

const Container = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, 56px);
  grid-column-gap: 150px;
  grid-row-gap: 84px;
  list-style-type: none;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
`;
